const projectData = [
    {
        skills: ["ReactJS", "React-Router", "Redux", "Authentication", "Formspree", "Google Map", "Number-Formattor"],
        heading: "E-Commerce Web App",
        projectLink: "https://dev-ak-ecom.netlify.app",
        description: "Here is my ECOM web application.",
        video: "https://www.youtube.com/embed/b7e24TAeYfA"
    },
    {
        skills: ["ReactJS", "React-Router", "Hire-order component", "Speech Recognition", "Firebase Authentication", "Context API"],
        heading: "YouTube Clone",
        projectLink: "https://yt-clone-001.netlify.app",
        description: "My own YouTube clone.",
        video: "https://www.youtube.com/embed/cg2-m_Lpxz4"
    },
    {
        skills: ["HTML", "CSS", "ReactJS", "Redux", "Redux-Persist"],
        heading: "Google Task Clone",
        projectLink: "https://google-task-clone.netlify.app",
        description: "Here I have created Google-Task-Clone, one of the biggest projects I have ever taken up. Learnt a lot from executing this project.",
        video: "https://www.loom.com/embed/556a7d3531e044c5913b4883bb79234f"
    },
    {
        skills: ["HTML", "CSS", "ReactJS", "Redux", "Redux-Persist"],
        heading: "ScoreKeeper App",
        projectLink: "https://scorekeeper-react-app.netlify.app",
        description: "Tried to create a simple score keeper app. It's fully responsive.",
        video: "https://www.loom.com/embed/5f0a5eef71834baa9c60d5315ac54f9d"
    },
    {
        skills: ["HTML", "CSS", "JavaScript", "ReactJS", "Axios"],
        heading: "Recipe App",
        projectLink: "https://recipe-gradients-app.netlify.app",
        description: "I have created a recipe project. Find your favorite recipe and related gradients.",
        video: "https://www.loom.com/embed/61d1da711f444b8e85e7de74fadd4646"
    },
    {
        skills: ["HTML", "CSS", "JavaScript", "ReactJS"],
        heading: "Task Management App",
        projectLink: "https://task-management-web-app.netlify.app",
        description: "Manage your tasks here.",
        video: "https://www.loom.com/embed/d376be119a2a40c19bfdf842ff4cce16"
    },
    {
        skills: ["HTML", "CSS", "JavaScript", "ReactJS", "Redux"],
        heading: "Tweet Page",
        projectLink: "https://twitter-tweet-page.netlify.app",
        description: "You can tweet here.",
        video: "https://www.loom.com/embed/152f169faa48425f812b0a28fc6736de"
    },
    {
        skills: ["HTML", "CSS", "ReactJS"],
        heading: "Step-Indicator",
        projectLink: "https://step-indicator.netlify.app",
        description: "Tried to create a simple responsive step indicator app.",
        video: "https://www.loom.com/embed/5b29b6de711040328d443b93b90b6115"
    },
    {
        skills: ["HTML", "CSS", "JavaScript", "ReactJS", "Axios", "useEffect"],
        heading: "Pagination Project",
        projectLink: "https://project-pagination.netlify.app",
        description: "I have created a project related to pagination using dummy data API. Switching every page API is called.",
        video: "https://www.loom.com/embed/654700734f8749709476c530c2d87e7a"
    },
    {
        skills: ["HTML", "CSS"],
        heading: " Hubhopper Clone",
        projectLink: "https://hubhopper-clone.netlify.app",
        description: "Just creating UI.",
        video: "https://www.loom.com/embed/bef112e00b10458abeec07c765e38baa"
    },
    {
        skills: ["HTML", "CSS"],
        heading: "Fitness App",
        projectLink: "https://my-gym-fitness-app.netlify.app",
        description: "This is just a UI.",
        video: "https://www.loom.com/embed/13e04eaeebcf482b810e80eca165b098"
    }
]

export {
    projectData
}
